import React, { FC, useState, useEffect } from 'react';
import IconButton from 'src/components/atoms/buttons/IconButton';
import { alertModalViewStore, confirmModalViewStore } from 'src/store/modal';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import Parse from 'html-react-parser';
import _ from 'lodash';
import './style.scss';

interface Props {
  boxStyleDef?: React.CSSProperties;
  styleDef?: React.CSSProperties;
}

/**
 * Modal 확인 창 레이아웃
 */
const ModalAlertLayout: FC<Props> = ({ boxStyleDef, styleDef }) => {
  const activeSet = alertModalViewStore(state => state.data);
  const setModalState = alertModalViewStore(state => state.set);
  const closeEvt = () => {
    setModalState({ data: {}, active: '' });
  };
  return (
    <div className={['_modal_alert_layout', activeSet.active].join(' ')}>
      <div className="_bg_box" onClick={closeEvt} />
      <div className="_content_box " style={boxStyleDef}>
        <div className="_title_div">
          <IconButton
            icon="ri-close-line"
            clickEvent={closeEvt}
            styleDef={{ fontSize: '25px', width: '25px', height: '25px' }}
          />
        </div>
        <div className="_condtent_div" style={styleDef}>
          <div className="_content ">
            <div className="_main">
              <div className="_icon">
                <i className={activeSet.data?.icon} />
              </div>
              <div className="_tit">{activeSet.data.mainTitle}</div>
            </div>
            <div className="_sub_main">
              {activeSet.data?.subTitle ? (
                <div className="_tit">{Parse(activeSet.data?.subTitle + '' || '')}</div>
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalAlertLayout;
